<template>
	<div :class="{ 'correct' : clicked && correct , 'incorrect' : clicked && !correct, 'show-correct' : showCorrect }" class="answer-btn">
		<div v-if="overlay" class="overlay">
			<div class="d-flex flex-row-reverse h-100">
				<h1 class="text-end text-white my-auto" style="line-height: 1;"><span v-html="t('overlay.quiz_text')"></span></h1>
			</div>
			<span class="hand-icon"></span>
		</div>
		<div class="d-flex h-100 w-100">
			<div class="answer-square" :class="{ 'correct-square' : clicked && correct , 'incorrect-square' : clicked && !correct, 'correct-square' : showCorrect }">
				<div class="d-flex h-100">
					<h1 class="my-auto mx-auto">{{ letter }}</h1>
				</div>
			</div>
			<h1 class="answer my-auto">{{ answer }}</h1>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "AnswerButton",
	props: {
		answerNumber: Number,
		answer: String,
		correct: Boolean,
		overlay: Boolean,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	data() {
		return {
			letter: "A",
			clicked: false,
			showCorrect: false,
		};
	},
	mounted() {
		// Convert number to Alphabet
		this.letter = String.fromCharCode(this.answerNumber + 65);
	},
	methods: {
		showCorrectAnswer() {
			if (this.correct) {
				this.showCorrect = true;
			}
		},
		click() {
			this.clicked = true;
		},
	},
};
</script>

<style scoped>
.overlay {
	position: absolute;
	left: calc( -100%  - 20px);
	width: 100%;
	height: 100%;
	bottom: 0;
}

.hand-icon {
	position: absolute;
	z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/hand.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 150px;
	width: 50px;
	top: 50px;
	right: -75px;
}

.answer-btn {
	position: relative;
	width: 579px;
	height: 126px;
	background-color: white;
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.28);
}

.answer-btn:not(:last-child) {
	margin-bottom: 36px;
}

.answer-square {
	min-width: 126px;
	height: 100%;
	background-color: #1F1F1F;
	margin-right: 42px;
}

.answer-square h1 {
	color: white;
	font-size: 70px;
}

h1.answer {
	line-height: 0.8;
	font-size: 35px;
	font-weight: 400;
	margin-right: 42px;
}

.show-correct {
	border: 4px solid #5d874c;
	background-color: #8bc480;
}

.correct {
	background-color: #8bc480;
}

.correct-square {
	background-color: #4f8944;
}

.incorrect {
	background-color: #de9e9e;
}

.incorrect-square {
	background-color: #9f3232;
}
</style>